import { useEffect, useState } from 'react';
import axios from 'axios';
import '../about/single_about_styles.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Fade } from "react-awesome-reveal";
import { useParams } from "react-router-dom";
import PageLoader from '../../components/global/loader/PageLoader';
import { InternalBanner } from "../../components/internals/InternalBanner";

export const SingleAbout = ({
    parent_slug
}) => {
    const { slug } = useParams();
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        fetchPageContent(slug);
    }, [slug]);

    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            console.log("dddd", parent_slug, slug)
            const { data } = await axios.get(
                parent_slug ? `/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${parent_slug}/${slug}` :   `/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${slug}`);

            console.log(data)            
            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title} - Alinea Law PLLC` : "About - Alinea Law PLLC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }

            setPageContent(data);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }


    useEffect(() => {
        if (isFetchingPageData) {
            document.body.classList.add('is-page-loading');
        } else {
            document.body.classList.remove('is-page-loading');
        }
    }, [isFetchingPageData]);



    return <Fade delay={1}>
        <main id="main" className="about">
            {!isFetchingPageData && <>
                <InternalBanner page={pageContent?.page} />
                <section id="single-about-section" className="internal-section">
                    <div className="container">
                        <article dangerouslySetInnerHTML={{__html: pageContent?.page?.post_content}}>    
                        </article>
                    </div>
                </section>
            </>}

            {isFetchingPageData && <>
                <PageLoader />
            </>}
        </main>
    </Fade>
}

export default SingleAbout;